import {
  ERROR_MESSAGE_INVALID_EMAIL,
  ERROR_MESSAGE_REQUIRED,
} from '@jobcost-monorepo/utils';
import * as z from 'zod';

export const schema = z.object({
  email: z
    .string({
      required_error: ERROR_MESSAGE_REQUIRED,
    })
    .email({
      message: ERROR_MESSAGE_INVALID_EMAIL,
    }),
});
